// extracted by mini-css-extract-plugin
module.exports = {"icon":"_21bbf1e","align":"_71f20b6","wrapper":"_3436044"};